'use client';

import { useState } from 'react';

import { css } from '@emotion/react';
import { Tab, Tabs, Box } from '@mui/material';
import { Types } from '@scorenco/core';

import { TabPanel } from '../../TabPanel';

import { RankingTab } from './_internal/RankingTab';

interface RankingWidgetProps {
  teams?: Types.Teams_Team_Detail[];
}

export const RankingWidget = ({ teams }: RankingWidgetProps) => {
  const [currentTab, setCurrentTab] = useState(0);
  return (
    <>
      {teams && teams?.length > 1 ? (
        <Box sx={{ width: '100%' }} className="multiple-teams">
          <Box
            sx={{ borderBottom: 1, borderColor: 'divider' }}
            className="tabs-container"
          >
            <Tabs
              value={currentTab}
              className="tabs"
              onChange={(_, tabIndex) => {
                setCurrentTab(tabIndex);
              }}
              centered
              variant={'scrollable'}
              scrollButtons="auto"
              allowScrollButtonsMobile
              css={() => css`
                .MuiTabs-scrollButtons.Mui-disabled {
                  opacity: 0.3;
                }
              `}
            >
              {teams?.map((team) => {
                return (
                  <Tab
                    key={team.id}
                    label={team.name_in_club}
                    className={`tab-${team.id}`}
                  />
                );
              })}
            </Tabs>
          </Box>

          {teams?.map((team, idx) => {
            return (
              <TabPanel
                key={team.id}
                value={currentTab}
                index={idx}
                className={`tab-panel-${team.id}`}
              >
                <RankingTab team={team} />
              </TabPanel>
            );
          })}
        </Box>
      ) : (
        <RankingTab team={teams?.[0]} />
      )}
    </>
  );
};
